import React from 'react';
import styles from './PlanSVG.module.scss';

interface IProps {
    svg: React.ReactElement;
    className?: string;
}

const PlanSVG = ({ svg, className }: IProps) => {
    return React.cloneElement(svg, {
        className: `${className} ${styles.planSVG}`,
    });
};

export default PlanSVG;
